// locales/en.ts
export const seo_en = {
  "seo.title": "Best Crypto Casino & Sportsbook Games Online | Housebets",
  "seo.description": "Join Housebets for crypto slots & sports betting...",
  "seo.keywords": "online casino, crypto sportsbook",
  "seo.og.image": "Simple registration, instant withdrawals, and exclusive perks",
};

// locales/ru.ts
export const seo_ru = {
  "seo.title": "Лучшее крипто-казино и ставки на спорт | Housebets",
  "seo.description": "Присоединяйтесь к Housebets для слотов и ставок...",
  "seo.keywords": "онлайн казино, крипто-букмекер",
  "seo.og.image": "Простая регистрация, мгновенные выплаты, эксклюзивные бонусы",
};


export const seoMessages: any = {
  en: {
    "seo.title": "Best Crypto Casino & Sportsbook Games Online | Housebets",
    "seo.description":
      "Join Housebets for crypto slots & sports betting. Enjoy fast payouts, live games, and exclusive bonuses in a secure online casino.",
    "seo.keywords": "online casino, crypto sportsbook",
    "seo.og.image": "Simple registration, instant withdrawals, and exclusive perks",
  },
  fr: {
    "seo.title": "Meilleur casino crypto et paris sportifs en ligne | Housebets",
    "seo.description":
      "Rejoignez Housebets pour des machines à sous crypto et des paris sportifs. Profitez de paiements rapides, de jeux en direct et de bonus exclusifs dans un casino en ligne sécurisé.",
    "seo.keywords": "casino en ligne, paris crypto",
    "seo.og.image": "Inscription simple, retraits instantanés et avantages exclusifs",
  },
  zh: {
    "seo.title": "最佳加密赌场与体育博彩游戏 | Housebets",
    "seo.description":
      "加入Housebets，享受加密老虎机和体育博彩。享受快速支付、真人游戏和独家奖金，在安全的在线赌场中畅玩。",
    "seo.keywords": "在线赌场，加密体育博彩",
    "seo.og.image": "简单注册，立即提现，独家福利",
  },
  es: {
    "seo.title": "Mejor casino y apuestas deportivas con criptomonedas | Housebets",
    "seo.description":
      "Únete a Housebets para tragamonedas cripto y apuestas deportivas. Disfruta de pagos rápidos, juegos en vivo y bonos exclusivos en un casino en línea seguro.",
    "seo.keywords": "casino en línea, apuestas cripto",
    "seo.og.image": "Registro simple, retiros instantáneos y beneficios exclusivos",
  },
  pt: {
    "seo.title": "Melhor cassino cripto e apostas esportivas online | Housebets",
    "seo.description":
      "Junte-se à Housebets para slots cripto e apostas esportivas. Aproveite pagamentos rápidos, jogos ao vivo e bônus exclusivos em um cassino online seguro.",
    "seo.keywords": "cassino online, apostas cripto",
    "seo.og.image": "Registro simples, retiradas instantâneas e benefícios exclusivos",
  },
  ko: {
    "seo.title": "최고의 암호화 카지노 및 스포츠북 게임 | Housebets",
    "seo.description":
      "Housebets에 가입하여 암호 슬롯 및 스포츠 베팅을 즐기세요. 빠른 출금, 라이브 게임, 독점 보너스를 안전한 온라인 카지노에서 즐기세요.",
    "seo.keywords": "온라인 카지노, 암호 스포츠북",
    "seo.og.image": "간단한 등록, 즉시 출금, 독점 혜택",
  },
  ja: {
    "seo.title": "最高の暗号カジノ＆スポーツブックゲーム | Housebets",
    "seo.description":
      "Housebetsに参加して、暗号スロットとスポーツベッティングを楽しもう。安全なオンラインカジノで、迅速な支払い、ライブゲーム、限定ボーナスを体験。",
    "seo.keywords": "オンラインカジノ, 暗号スポーツブック",
    "seo.og.image": "簡単登録、即時出金、限定特典",
  },
  de: {
    "seo.title": "Bestes Krypto-Casino & Sportwetten online | Housebets",
    "seo.description":
      "Tritt Housebets für Krypto-Slots und Sportwetten bei. Genieße schnelle Auszahlungen, Live-Spiele und exklusive Boni in einem sicheren Online-Casino.",
    "seo.keywords": "Online-Casino, Krypto-Sportwetten",
    "seo.og.image": "Einfache Registrierung, sofortige Auszahlungen und exklusive Vorteile",
  },
  hu: {
    "seo.title": "Legjobb kripto kaszinó és sportfogadás | Housebets",
    "seo.description":
      "Csatlakozz a Housebetshez kripto nyerőgépekért és sportfogadásokért. Élvezd a gyors kifizetéseket, élő játékokat és exkluzív bónuszokat egy biztonságos online kaszinóban.",
    "seo.keywords": "online kaszinó, kripto sportfogadás",
    "seo.og.image": "Egyszerű regisztráció, azonnali kifizetések és exkluzív előnyök",
  },
  tr: {
    "seo.title": "En İyi Kripto Casino ve Spor Bahisleri | Housebets",
    "seo.description":
      "Kripto slotlar ve spor bahisleri için Housebets'e katılın. Hızlı ödemelerin, canlı oyunların ve özel bonusların keyfini güvenli bir çevrimiçi casinoda çıkarın.",
    "seo.keywords": "çevrimiçi casino, kripto bahis",
    "seo.og.image": "Basit kayıt, anında çekim ve özel avantajlar",
  },
  ru: {
    "seo.title": "Лучшее крипто-казино и ставки на спорт | Housebets",
    "seo.description":
      "Присоединяйтесь к Housebets для слотов и ставок на спорт с криптовалютой. Наслаждайтесь быстрыми выплатами, живыми играми и эксклюзивными бонусами в безопасном онлайн-казино.",
    "seo.keywords": "онлайн казино, крипто-букмекер",
    "seo.og.image": "Простая регистрация, мгновенные выплаты и эксклюзивные бонусы",
  },
  vi: {
    "seo.title": "Sòng bạc & Thể thao trực tuyến tốt nhất bằng crypto | Housebets",
    "seo.description":
      "Tham gia Housebets cho các trò chơi slots crypto và cá cược thể thao. Thưởng thức thanh toán nhanh, trò chơi trực tiếp và các ưu đãi độc quyền tại sòng bạc trực tuyến an toàn.",
    "seo.keywords": "casino trực tuyến, crypto sportsbook",
    "seo.og.image": "Đăng ký đơn giản, rút tiền ngay lập tức và ưu đãi độc quyền",
  },
};
